/**
 * Application Configuration
 * Handles environment-specific settings for API endpoints
 */

// Get API base URL from environment variable.
// In development, leave empty so requests use relative URLs
// and go through the CRA proxy (defined in package.json).
const API_BASE = process.env.REACT_APP_API_URL || '';

// Validate API URL is reachable (dev-only diagnostic, silent in production)
const validateApiUrl = async () => {
  try {
    await fetch(`${API_BASE}/health`, {
      method: 'HEAD',
      mode: 'no-cors', // Don't fail on CORS during health check
    });
    console.log('✅ API server is reachable at', API_BASE);
  } catch (error) {
    console.warn('⚠️ API server may not be reachable at', API_BASE);
    console.warn('Make sure server is running: npm start in server directory');
    console.warn('Or set REACT_APP_API_URL environment variable');
  }
};

// Run validation on app load (non-blocking), development only.
// Skipped in tests so it doesn't pollute mocked fetch calls with a
// phantom /health request a second into the test.
if (typeof window !== 'undefined' && process.env.NODE_ENV === 'development') {
  setTimeout(validateApiUrl, 1000);
}

export { API_BASE, validateApiUrl };
